import React from 'react'
import mockdata from "../../MockData/mockdata.json"
import { auth, firestore, storage } from '../../utils/firebase';
import { merge } from '../../utils/dates';
import { v4 as uuidv4 } from 'uuid';
import { useAuthState } from 'react-firebase-hooks/auth';
import firebase from 'firebase';
import { Job } from '../../typings/Job';
import { Actions } from '../../typings/actions';

export const DataContext = React.createContext(null as unknown as { data: any; actions: Actions });

export default function ContextWrapper(props) {
    const [user, loading, error] = useAuthState(auth);

    const emptyData = {
        Jobs: [],
        tenantID: ""
    };

    const [data, setData] = React.useState(emptyData as any);

    React.useEffect(() => {
        if (user) {
            actions.Auth.GetTenantIDandRoleIDbyUserID(user?.uid)
        }
        // if (process.env.NODE_ENV !== 'production') {
        //     setData(mockdata);
        // }
    }, [user])


    const actions: Actions = {
        Auth: {
            GetTenantIDandRoleIDbyUserID: async (UserID) => {
                var doc = await firestore.collection("users").doc(UserID).get();
                console.log(doc.data()?.Role)
                setData({
                    ...data, Role: doc.data()?.Role, tenantID: doc.data()?.TenantID
                })
            },
            Logout: () => {
                auth.signOut()
            },
            Clear: () => {
                setData(undefined);
            }
        },
        Job: {
            AddJob: async (job: Job) => {
                let ID = uuidv4();
                job.ID = ID;
                var doc = await firestore
                    .collection("tenants")
                    .doc(job.TenantID)
                    .collection("jobs")
                    .doc(ID).set({ ...job });

                return doc;
            },
            EditJob: async (job) => {
                var doc = await firestore
                    .collection("tenants")
                    .doc(job.TenantID)
                    .collection("jobs")
                    .doc(job.ID).update({ ...job, ID: job.ID }, { merge: true });

                return doc;
            },
            DeleteJob: async (TenantID, JobID) => {
                return await firestore
                    .collection("tenants")
                    .doc(TenantID)
                    .collection("jobs")
                    .doc(JobID)
                    .delete()
            },
            SetNewlyCreatedJobID: (JobID) => {
                setData({ ...data, newlyCreatedJobID: JobID })
            },
            GetJobByID: async (JobID, TenantID) => {
                console.log("tenantID", TenantID)
                var doc = await firestore
                    .collection("tenants")
                    .doc(TenantID)
                    .collection("jobs")
                    .doc(JobID)
                    .get();

                return doc.data()
            },
            GetJobsByTenantID: async (tenantID) => {
                var jobCollection = await firestore
                    .collection("tenants")
                    .doc(tenantID)
                    .collection("jobs").get();

                var jobsArray = [];

                jobCollection.forEach(doc => {
                    jobsArray.push(doc.data());
                });
                setData({ ...data, Jobs: jobsArray })
            },
            SetCurrentJob: (job) => {
                setData({ ...data, Job: job })
            }
        },
        Task: {
            AddTask: async (TenantID, JobID, TaskID, taskPayload) => {

                const increment = firebase.firestore.FieldValue.increment(1);

                const taskRef = firestore
                    .collection("tenants")
                    .doc(TenantID)
                    .collection("jobs")
                    .doc(JobID)
                    .collection("tasks")
                    .doc(TaskID)
                const statsRef = firestore
                    .collection("tenants")
                    .doc(TenantID)
                    .collection("jobs")
                    .doc(JobID)
                    .collection("tasks")
                    .doc("--stats--")


                let position = ((await (statsRef.get())).data())?.runningTaskCount || 0

                const dataToBeAdded = {
                    ...taskPayload, Position: position
                }


                const batch = firestore.batch();

                batch.set(taskRef, dataToBeAdded);
                batch.set(statsRef, { taskCount: increment, runningTaskCount: increment }, { merge: true });
                return batch.commit();
            },
            DeleteTask: async (TenantID, JobID, TaskID) => {

                const increment = firebase.firestore.FieldValue.increment(1);
                const decrement = firebase.firestore.FieldValue.increment(-1);

                const taskRef = firestore
                    .collection("tenants")
                    .doc(TenantID)
                    .collection("jobs")
                    .doc(JobID)
                    .collection("tasks")
                    .doc(TaskID);

                const statsRef = firestore
                    .collection("tenants")
                    .doc(TenantID)
                    .collection("jobs")
                    .doc(JobID)
                    .collection("tasks")
                    .doc("--stats--")

                const batch = firestore.batch();

                batch.delete(taskRef);
                batch.set(statsRef, { taskCount: decrement }, { merge: true });
                return batch.commit();

            },
            EditTask: async (TenantID, JobID, TaskID, taskPayload) => {
                return await firestore
                    .collection("tenants")
                    .doc(TenantID)
                    .collection("jobs")
                    .doc(JobID)
                    .collection("tasks")
                    .doc(TaskID)
                    .update(taskPayload);
            },
            MoveTask: async (TenantID, JobID, currentDoc, targetDoc) => {

                console.log(currentDoc)

                const currentTaskRef = firestore
                    .collection("tenants")
                    .doc(TenantID)
                    .collection("jobs")
                    .doc(JobID)
                    .collection("tasks")
                    .doc(currentDoc.TaskID);


                const targetTaskRef = firestore
                    .collection("tenants")
                    .doc(TenantID)
                    .collection("jobs")
                    .doc(JobID)
                    .collection("tasks")
                    .doc(targetDoc.TaskID);

                const batch = firestore.batch();

                batch.update(currentTaskRef, { Position: targetDoc.Position });
                batch.update(targetTaskRef, { Position: currentDoc.Position });
                return batch.commit();

            }
        },
        Storage: {
            AddFileAndGetFileObject: async (file: any) => {
                console.log("IM HERE", file)

                if (file.isAdded) { return file; }
                else {
                    var newName = uuidv4();
                    const storageRef = storage.ref();
                    const fileRef = storageRef.child(newName);
                    const uploadedImage = await fileRef.put(file);
                    const url = await uploadedImage.ref.getDownloadURL();
                    return { url: url, type: file.type, name: newName };
                }
            },
            Deletefile: async (files: any) => {
                console.log(files)
                var storage = firebase.storage();
                try {

                    files.forEach(file => {
                        const storageRef = storage.refFromURL(file.url)

                        storageRef.delete()
                    })

                }
                catch (e) {
                    console.log(e)
                }
            }
        },
        setPathFrom: (pathFrom) => {
            setData({ ...data, pathFrom: pathFrom })
        },
        setTenantID: tenantID => {
            console.log("ran")
            setData({ ...data, tenantID: tenantID })
        },
        getAndSetTenantID: async (userID) => {
            var doc = await firestore.collection("users").doc(userID).get()

            if (!doc.exists) {
                console.log('No such document!');
            } else {
                setData({ ...data, tenantID: doc.data().TenantID })
            }
        },
        getTenantBusinessName: async (tenantID) => {
            console.log(tenantID)
            var doc = await firestore.collection("tenants").doc(tenantID).get()

            if (!doc.exists) {
                console.log('No biz document!');
            } else {
                setData({ ...data, Tenant: doc.data() })
            }
        },
        addUserToTenant: async (tenantID, userID, name, email) => {
            var doc = await firestore.collection("tenants").doc(tenantID).collection("users").doc(userID).set({
                UserID: userID,
                Name: name,
                Email: email
            }, { merge: true })

        },
        addUserOnSignUp: data => {

        },
        addJob: job => {
            setData({ ...data, Jobs: data.Jobs.concat(job) })
        }
    }



    return (
        <DataContext.Provider value={{ data, actions }}>
            {props.children}
        </DataContext.Provider>
    )
}